import React from 'react';
import moment from 'moment';
//import Fade from 'react-reveal/Fade';
import { Spring } from 'react-spring/renderprops';

const Event = ({ edge }) => {
	const { eventId, title, event_information } = edge.node;
	const { time, location } = event_information;

	// location
	let renderedLocation;
	if (location.roomName) {
		renderedLocation = <p className="event-location">{location.roomName}<br />
			{location.roomNumber} {location.buildingName}</p>
	} else {
		renderedLocation = <p className="event-location">{location.roomNumber} {location.buildingName}</p>
	}
	
	// time
	let startDate = moment(time.start);
	let endDate = moment(time.end);
	let renderedTime;
	if (time.end) {
		renderedTime = <h4 className="event-time">{startDate.format('h:mm')}-{endDate.format('h:mm a')}</h4>
	} else {
		renderedTime = <h4 className="event-time">{startDate.format('h:mm a')}</h4>
	}

	return (
		<Spring
			from={{ left: -20 }}
			to={{ left: 0 }}>
			{props => <article key={eventId} className="event">
			{renderedTime}
			<h3 className="event-title">{title}</h3>
			{renderedLocation}
		</article>}
		</Spring>
	);
};

export default Event;
